import DOMPurify from 'dompurify'

// 配置DOMPurify白名单（仅保留业务需要的标签/属性，可根据需求扩展）
const safeHtmlOptions = {
    ALLOWED_TAGS: ['p', 'br', 'img', 'h1', 'h2', 'strong', 'em', 'u', 'span'],
    ALLOWED_ATTR: ['src', 'alt', 'title', 'class', 'style'],
    DISALLOW_ATTR: ['on*', 'href', 'srcdoc', 'data-*'], // 禁止所有事件属性、危险链接
    ALLOWED_STYLES: ['color', 'font-size', 'text-align', 'font-weight'], // 仅允许基础样式
    FORBID_TAGS: ['script', 'iframe', 'embed', 'svg', 'form'], // 强制禁止高危标签
    FORBID_ATTR: ['onclick', 'onload', 'onerror', 'href']
}

// 注册Vue2全局指令v-safe-html
export default {
    install(Vue) {
        Vue.directive('safeHtml', {
            bind(el, binding) {
                // 过滤内容并渲染
                el.innerHTML = DOMPurify.sanitize(binding.value || '', safeHtmlOptions)
            },
            update(el, binding) {
                // 数据更新时重新过滤渲染
                if (binding.oldValue !== binding.value) {
                    el.innerHTML = DOMPurify.sanitize(binding.value || '', safeHtmlOptions)
                }
            }
        })
    }
}